'use client'
import { FunctionComponent } from 'react'
import { useTranslation } from '../../context/ConfigContext'

interface CarvingPreviewType extends Carving {
  onEdit: () => void
}

const CarvingPreview: FunctionComponent<CarvingPreviewType> = ({ text, font, onEdit }) => {
  const t = useTranslation()

  return (
    <div className='carving-recap'>
      <div className='carving-edit'>
        <p>{t('faq-entretien-messika-title-1', {}, true)}</p>
        <button type='button' onClick={onEdit}>
          {t('Refine')}
        </button>
      </div>
      <input className={`carving-preview ${font}`} value={text} disabled />
      <p className='carving-desc'>{t('Expect an additional delay of 5 days.', {}, true)}</p>
    </div>
  )
}

export default CarvingPreview
